
import React, { Component } from 'react';
import "./f2.css";

class Footer2 extends Component{
  
    render(){
        return (
            <div className="f2">
                <p>Made with <span className="heart">❤ </span> Sambhav & Iishi</p>
            </div>
        )
        }
}

export default Footer2